import { z } from 'zod';
/** Reverse-geocode result for a manually dropped pin (SPEC §1.2). */
export const geocodeResultSchema = z.object({
    label: z.string(),
    lat: z.number(),
    lng: z.number(),
});
//# sourceMappingURL=geocode.js.map